/* unplugin-vue-components disabled */import script from "./weChat.vue?vue&type=script&setup=true&lang=js"
export * from "./weChat.vue?vue&type=script&setup=true&lang=js"

import "./weChat.vue?vue&type=style&index=0&id=0d7e8e2c&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d7e8e2c"]])

export default __exports__